import { render } from "./TabWatchList.vue?vue&type=template&id=3ab3add0"
import script from "./TabWatchList.vue?vue&type=script&lang=js"
export * from "./TabWatchList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__